module.exports = __webpack_public_path__ + "img/logo_fcf.a50025b2.jpeg";